export default __webpack_public_path__ + "assets/tanzania-flag.png";